// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".callout__extended[data-v-90385340] .col.p-2.ml-2 {\n  padding: unset !important;\n}\n@media only screen and (max-width: 768px) {\n.btn-block-xs-only[data-v-90385340] {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n}\n}", ""]);
// Exports
module.exports = exports;
